import { SessionsUsagePage } from '@features/usage/components/sessions/SessionsUsagePage'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { paginationRequestSchema } from '@customTypes/cloudmix/api'
import { withListHydration } from '@lib/listState/withListHydration'

const routerSchema = paginationRequestSchema.partial().catch({})
export const Route = createFileRoute('/_auth/o/$orgId/usage/sessions')({
  component: SessionsUsagePage,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {},
    getTitle: () => 'Session Usage',
  }),
})
